import { useRef, useEffect, useState } from "react";
import Pagination from "../../../../Components/Pagination";
import Button from "../../../../Core/Button/Button";
import SearchableDropdown from "../../../../Core/Fields/Floating/SearchableDropdown";
import GetIcon from "../../../../utils/Icon";
const TableTab2 = ({
  setselected_default_item_data,
  selected_default_item_data,
  company_list_data,
  warehouse_list_data,
  price_list,
  po_status,
}) => {
  const createNewRow = () => ({
    company: "",
    default_warehouse: "",
    default_price_list: "",

  });

  const tableRef = useRef();
const dropdownRef = useRef(null);
const dropdownRef1 = useRef(null);
  const [rowsPerPage] = useState(10);
 // For "item_tax" dropdown
const [offset, setOffset] = useState(0);
const [search_input, setsearch_input] = useState("");

// For "default_warehouse" dropdown
const [offset1, setOffset1] = useState(0);
const [search_input1, setsearch_input1] = useState("");

// Pagination control (optional but required if used)
const [hasMore, setHasMore] = useState(true);            // for item_tax
const [hasMoreCategory, setHasMoreCategory] = useState(true); // for default_warehouse

  const [item_tax_list, setcomapny_list] = useState([]);
  const [item_default_warehouse_list, setitem_default_warehouse_list] = useState([]);
  const [item_default_price_list, setitem_default_price_list] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rows, setRows] = useState([createNewRow()]);
  const [selectedRows, setSelectedRows] = useState([]);
  // const [search_input, setsearch_input] = useState("");
const [focusedCell, setFocusedCell] = useState({ rowIndex: null, field: null });
const [showDropdown, setShowDropdown] = useState({ rowIndex: null, field: null });
  const isAllSelected = rows.length > 0 && selectedRows.length === rows.length;
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = rows.slice(indexOfFirstRow, indexOfLastRow);

// console.log('tab2:',selected_default_item_data)
 useEffect(() => {
    if (selected_default_item_data) {
    setRows(selected_default_item_data);
    // const unfrozenData = selected_default_item_data.map(obj => ({ ...obj }));
  // setRows(unfrozenData);
  }
  }, [selected_default_item_data]);

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allRowIndices = rows.map((_, index) => index);
      setSelectedRows(allRowIndices);
    } else {
      setSelectedRows([]);
    }
  };

  const getCompany = async (newOffset = 0, searchText = "") => {
    const res = await company_list_data({
      start: newOffset,
      search_input: searchText,
    });
    const products = res?.data?.data || [];
    // console.log('tax list:',products)
    if (newOffset === 0) {
      setcomapny_list(products);
    } else {
      setcomapny_list((prev) => [...prev, ...products]);
    }
    setHasMore(products.length === 10);
  };

  const getItemdefault_warehousedata = async (newOffset = 0, searchText = "") => {
    const res = await warehouse_list_data({
      start: newOffset,
      search_input: searchText,
    });
    const products = res?.data?.data || [];
    // console.log('tax cat list:',products)
    if (newOffset === 0) {
      setitem_default_warehouse_list(products);
    } else {
      setitem_default_warehouse_list((prev) => [...prev, ...products]);
    }
    setHasMore(products.length === 10);
  };

  const getPriceList = async (newOffset = 0, searchText = "") => {
    const res = await price_list({
      start: newOffset,
      search_input: searchText,
    });
    const products = res?.data?.data || [];
    // console.log('tax cat list:',products)
    if (newOffset === 0) {
      setitem_default_price_list(products);
    } else {
      setitem_default_price_list((prev) => [...prev, ...products]);
    }
    setHasMore(products.length === 10);
  };


const updateRow = (index, field, value) => {
  const updatedRows = [...rows];

  // Deep copy the row
  const row = { ...updatedRows[index] };

  // If the field is inside 'item', handle it accordingly
  if (row.item && field in row.item) {
    row.item = { ...row.item, [field]: value };
  } else {
    row[field] = value;
  }

  updatedRows[index] = row;

  setRows(updatedRows);
  setselected_default_item_data(updatedRows);
};

  const toggleRowSelection = (index) => {
    setSelectedRows((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const handleAddRow = () => {
    const newRows = [...rows, createNewRow()];
    setRows(newRows);
    setselected_default_item_data(newRows);
    const lastPage = Math.ceil(newRows.length / rowsPerPage);
    if (currentPage !== lastPage) {
      setCurrentPage(lastPage);
    }
  };

  const handleDeleteSelectedRows = () => {
    const updatedRows = rows.filter((_, idx) => !selectedRows.includes(idx));
    setRows(updatedRows);
    setselected_default_item_data(updatedRows);
    setSelectedRows([]);
    const lastPage = Math.ceil(updatedRows.length / rowsPerPage);
    if (currentPage > lastPage) {
      setCurrentPage(lastPage);
    }
  };

  useEffect(() => {
    getCompany(0, "");
    getItemdefault_warehousedata(0, "");
    getPriceList(0, "");
  }, []);



  useEffect(() => {
    const cols = tableRef.current.querySelectorAll("th");
    cols.forEach((col) => {
      const resizer = document.createElement("div");
      resizer.className = "resizer";
      col.appendChild(resizer);

      let x = 0;
      let w = 0;

      const onMouseDown = (e) => {
        x = e.clientX;
        w = col.offsetWidth;

        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
      };

      const onMouseMove = (e) => {
        const dx = e.clientX - x;
        col.style.width = `${w + dx}px`;
      };

      const onMouseUp = () => {
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
      };

      resizer.addEventListener("mousedown", onMouseDown);
    });
  }, []);

  return (
    <div className="">
      <table className="table table-bordered mb-1" ref={tableRef}>
        <thead className="tableHead1">
          <tr>
            {[
              "Action",
              "S.No",
              "Company",
              "Default Warehouse",
              "Default Price List",
              <GetIcon iconName="PiSlidersHorizontalBold" size={12} />
            ].map((title, i) => {
              const isIcon = typeof title !== "string";
              const defaultWidths = {
                Action: "54px",
                "S.No": "54px",
                "Company": "303px",
                "Default Warehouse": "303px",
                "Default Price List": "303px",
                Action1: "303px",
              };

              return (
                <th
                  key={i}
                  style={{
                    fontSize: "7px",
                    position: "relative",
                    textAlign:
                      title === "Action" ||
                      title === "S.No" ||
                      title === "isIcon"
                        ? "center"
                        : "center",

                     width:
            typeof title === "string" ? defaultWidths[title] || "303px" : "303px",
          minWidth:
            typeof title === "string" ? defaultWidths[title] || "303px" : "303px",
                  }}
                >
                  {title === "Action" ? (
                    <input
                      type="checkbox"
                      className="form-check-input"
                      style={{
                        backgroundColor: isAllSelected ? "#270b79" : "",
                        borderColor: isAllSelected ? "#270b79" : "",
                        fontSize: "15px",
                      }}
                      checked={isAllSelected}
                      onChange={handleSelectAll}
                    />
                  ) : isIcon ? (
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            {title}
          </div>
        ) : (
          title
        )}
                </th>
              );
            })}
          </tr>
        </thead>

        <tbody>
          {currentRows.map((row, index) => {
            const globalIndex = indexOfFirstRow + index;
            return (
              <tr key={globalIndex}>
                <td className="p-0" style={{ cursor: "pointer" }}>
                  <p
                    className="m-0"
                    style={{ position: "relative", top: "5px" }}
                  >
                    {selectedRows.includes(globalIndex) ? (
                      <span onClick={() => toggleRowSelection(globalIndex)}>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          style={{
                            backgroundColor: "#270b79",
                            fontSize: "15px",
                            borderColor: "#270b79",
                          }}
                          checked
                        />
                      </span>
                    ) : (
                      <span onClick={() => toggleRowSelection(globalIndex)}>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          style={{ fontSize: "15px" }}
                        />
                      </span>
                    )}
                  </p>
                </td>
                <td
                  style={{
                    textAlign: "center",
                    fontSize: '0.8rem',textAlign: "center",
                    padding: "0.5rem",
                  }}
                >
                  {globalIndex + 1}
                </td>
<td className="p-0">
  {row && (
 <SearchableDropdown
  globalIndex={globalIndex}
  field="company"
  value={row?.item?.company ?? row?.company ?? ""}
  onChange={(val) => updateRow(globalIndex, "company", val)}
  onSearch={(text) => getCompany(0, text)}
  dropdownData={item_tax_list}
  placeholder="Select Company"
  focusedCell={focusedCell}
  setFocusedCell={setFocusedCell}
  showDropdown={showDropdown}
  setShowDropdown={setShowDropdown}
  dropdownRef={dropdownRef}
  setOffset={setOffset}
  offset={offset}
  search_input={search_input}
  hasMore={hasMore}
  getData={getCompany}
      createNewUrl="/master/company/create-Company"
  createNewLabel="+ Create Company"
/>
)}

</td>

<td className="p-0">
  <SearchableDropdown
  globalIndex={globalIndex}
  field="default_warehouse"
  value={row?.item?.default_warehouse ?? row?.default_warehouse ?? ""}
  onChange={(val) => updateRow(globalIndex, "default_warehouse", val)}
  onSearch={(text) => getItemdefault_warehousedata(0, text)}
  dropdownData={item_default_warehouse_list}
  placeholder="Select Default Warehouse"
  focusedCell={focusedCell}
  setFocusedCell={setFocusedCell}
  showDropdown={showDropdown}
  setShowDropdown={setShowDropdown}
  dropdownRef={dropdownRef1}
  setOffset={setOffset1}
  offset={offset1}
  search_input={search_input1}
  hasMore={hasMoreCategory}
  getData={getItemdefault_warehousedata}
   createNewUrl="/master/create-warehouse"
  createNewLabel="+ Create Warehouse"
/>


 
</td>

   <td className="p-0">
  <SearchableDropdown
  globalIndex={globalIndex}
  field="default_price_list"
  value={row?.item?.default_price_list ?? row?.default_price_list ?? ""}
  onChange={(val) => updateRow(globalIndex, "default_price_list", val)}
  onSearch={(text) => getPriceList(0, text)}
  dropdownData={item_default_price_list}
  placeholder="Select Default Price List"
  focusedCell={focusedCell}
  setFocusedCell={setFocusedCell}
  showDropdown={showDropdown}
  setShowDropdown={setShowDropdown}
  dropdownRef={dropdownRef1}
  setOffset={setOffset1}
  offset={offset1}
  search_input={search_input1}
  hasMore={hasMoreCategory}
  getData={getPriceList}
/>


 
</td>            

                <td
                  style={{
                    position: "relative",
                    width: "40px",
                  }}
                >
                  <img
                    src="/Maskgroup.png"
                    alt="edit"
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      width: "12px",
                      height: "12px",
                      pointerEvents: "none",
                    }}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <div
        className="d-flex pb-2  justify-content-between align-items-center"
        style={{ marginTop: "12px", marginBottom: "16px" }}
      >
        <div className="d-flex" style={{ gap: "4px" }}>
          {selectedRows.length > 0 && (
            <Button
              onClick={handleDeleteSelectedRows}
              className="customdeletebtn "
              iconName="MdDeleteOutline"
              iconSize={12}
            >
              Delete
            </Button>
          )}
          {selectedRows.length == 0 && (
            <Button
              onClick={handleAddRow}
              className="Addrowdesign"
              iconName="FiPlus"
              iconSize={12}
              iconWrapperStyle={{
                backgroundColor: "#ff8d5c",
                padding: "1px",
                display: "flex",
              }}
            >
              Add Row
            </Button>
          )}
        </div>

        <div
          className={`${
            rows.length < 11 ? "d-none" : "d-flex"
          } align-items-center centerpagination`}
          style={{ gap: "5px" }}
        >
          <Pagination
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            pageSize={rowsPerPage}
            totalrecords={rows.length}
          />
        </div>

        <div className={`${rows.length < 11 ? "d-none" : "d-flex"}`}>
          <span className="px-2" style={{ fontSize: "12px", color: "#270B79" }}>
            Showing {indexOfFirstRow + 1} to{" "}
            {Math.min(indexOfLastRow, rows.length)} of {rows.length} entries
          </span>
        </div>
      </div>
    </div>
  );
};

export default TableTab2;
